const CryptoJS = require("crypto-js");

// Set the encryption key (must match backend)
const SECRET_KEY = "4b227777d4dd1fc61c6f884f48641d02"; // Change if different in .env

// Function to encrypt data
function encryptData(data) {
    try {
        const encryptedText = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
        return encryptedText;
    } catch (error) {
        console.error("Encryption Error:", error);
        return null;
    }
}

// Function to decrypt data
function decryptData(encryptedData) {
    try {
        const decryptedText = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY).toString(CryptoJS.enc.Utf8);
        return decryptedText ? JSON.parse(decryptedText) : null;
    } catch (error) {
        console.error("Decryption Error:", error);
        return null;
    }
}

// Middleware to encrypt request data
function encryptRequest(req, res, next) {
    if (req.body) {
        req.body = encryptData(req.body);
    }
    next();
}

// Middleware to decrypt response data
function decryptResponse(req, res, next) {
    const originalSend = res.send;
    res.send = function (body) {
        if (body?.data) {
            body.data = decryptData(body.data);
        }
        originalSend.call(this, body);
    };
    next();
}

module.exports = {
    encryptData,
    decryptData,
    encryptRequest,
    decryptResponse
};
